<form id="search" [formGroup]="searchForm" (keydown.enter)="search()">
  <mat-accordion name="color" class="colorAccordion">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header  [collapsedHeight]="'48px'" [expandedHeight]="'64px'">
        <mat-panel-title [translate]="'search.shade'"></mat-panel-title>
      </mat-expansion-panel-header>
      <div class="color">

          <mat-form-field>
              <mat-label>{{'search.paintLine' | translate}}</mat-label>
              <mat-select formControlName="technology" (selectionChange)="launchMixitCloud($event)">
                  <mat-option *ngIf="!Utils.isAkzo(role)" value="ixell">IxellTech & Brillant direct</mat-option>
                  <mat-option *ngIf="!Utils.isAkzo(role)" value="oxelia">Oxelia & Brillant direct</mat-option>
                  <mat-option *ngIf="!Utils.isAxalta(role)" value="equinox">Equinox & Brillant direct</mat-option>
              </mat-select>
          </mat-form-field>

          <div class="textControl">
              <mat-form-field>
                  <mat-label>{{'search.colorCode' | translate}}</mat-label>
                  <input matInput type="text" formControlName="colorCode" (input)="selectCodes()" list="codeList" autocomplete="off" />
                  <datalist id="codeList">
                      <select>
                          <option *ngFor="let c of codeList" value="{{c}}"></option>
                      </select>
                  </datalist>
              </mat-form-field>
              <mat-radio-group matra formControlName="codeSearch">
                  <mat-radio-button [value]=0 [checked]="true">{{'search.began'|translate}}</mat-radio-button>
                  <mat-radio-button [value]=1>{{'search.contains'|translate}}</mat-radio-button>
              </mat-radio-group>
          </div>
          <div class="textControl">
              <mat-form-field>
                  <mat-label>{{'search.designation' | translate}}</mat-label>
                  <input matInput type="text" formControlName="designation" (input)="selectDesignations()" list="designationList" autocomplete="off" />
                  <datalist id="designationList">
                      <select>
                          <option *ngFor="let c of designationList" value="{{c}}"></option>
                      </select>
                  </datalist>
              </mat-form-field>
              <mat-radio-group formControlName="designationSearch">
                  <mat-radio-button [value]=0 [checked]="true">{{'search.began'|translate}}</mat-radio-button>
                  <mat-radio-button [value]=1> {{'search.contains'|translate}}</mat-radio-button>
              </mat-radio-group>
          </div>
          <mat-form-field>
              <mat-label>{{'search.formuleNum' | translate}}</mat-label>
              <input matInput type="number" formControlName="formuleNum" />
          </mat-form-field>
          <mat-form-field>
              <mat-label>{{'search.shadeGuideNum' | translate}}</mat-label>
              <input matInput type="text" formControlName="shadeGuideNum" />
          </mat-form-field>
          <mat-form-field>
              <mat-label>{{'search.color' | translate}}</mat-label>
              <mat-select formControlName="colorGroup">
                  <mat-option *ngFor="let color of colorList" value="{{color.num}}">{{color.libelle}}</mat-option>
              </mat-select>
          </mat-form-field>

          <mat-checkbox formControlName="searchWorld" id="searchWorld" class="checkbox-margin" [checked]="false">{{ 'references.SearchWorld' | translate }}</mat-checkbox>

      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion name="vehicle" class="vehicleAccordion">
    <mat-expansion-panel [expanded]="expandVehicle">
      <mat-expansion-panel-header  [collapsedHeight]="'48px'" [expandedHeight]="'64px'">
        <mat-panel-title [translate]="'search.vehicle'"></mat-panel-title>
      </mat-expansion-panel-header>
      <div class="vehicle">
        <mat-form-field>
          <mat-label>{{'common.manufacturer' | translate}}</mat-label>
          <input matInput type="text" formControlName="manufacturer" (ngModelChange)="selectManufacturers()" list="manufacturerList" autocomplete="off" />
          <datalist id="manufacturerList">
            <select>
              <option *ngFor="let m of manufacturerList" value="{{m}}"></option>
            </select>
          </datalist>
        </mat-form-field>
        <!--<div *ngIf="searchForm.controls['manufacturer'].value.toLowerCase() == 'ford' || searchForm.controls['manufacturer'].value.toLowerCase() == 'ford europe' ">
          <mat-form-field>
            <mat-label>VIN</mat-label>
            <input matInput type="text" formControlName="vin" maxlength="17" (input)="checkVin($event)" autocomplete="off" />
          </mat-form-field>
          <label class="error">{vinerror}}</label>
          <label class="error" *ngIf="errorFord">{'search.fordError' | translate}}</label>
        </div>-->
        <mat-form-field>
          <mat-label>{{'search.model' | translate}}</mat-label>
          <input matInput type="text" formControlName="model" list="modelList" autocomplete="off" />
          <datalist id="modelList">
            <select>
              <option *ngFor="let mo of modelList" value="{{mo}}"></option>
            </select>
          </datalist>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'search.year' | translate}}</mat-label>
          <input matInput type="number" formControlName="year" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'search.application' | translate}}</mat-label>
          <mat-select formControlName="application">
            <mat-option *ngFor="let a of applicationList" value="{{a.codeInfo}}">{{a.libelle}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</form>
<div class="btnContainer">
  <div class="row error">
    <span class="col-sm-6 col-12 offset-sm-3" id="errorlbl" [translate]="'search.errorSearch'"></span>
  </div>
  <div class="row btns">
    <button class="eraseBtn" (click)="erase()" [translate]="'search.eraseBtn'"></button>
    <button class="searchBtn" (click)="search()" [translate]="'search.searchBtn'"></button>
  </div>
</div>

<!--Modale Loading-->
<div id="loadingModal" class="modal">
  <div class="modal-content" id="loadingContent">
    <div class="loader loader-black">
      <mat-spinner diameter="70"> </mat-spinner>
      <span>Intérrogation des services FORD</span>
    </div>
  </div>
</div>
